<template>
  <div class="position-relative account-list-unwrapper">
    <div class="row mb-4">
      <HeraSearchInput
        v-if="hasSearch"
        v-model="userFilter"
        :placeholder="
          $t('_web_account-contacts_list_search-placeholder', 'Search...')
        "
        class="col-lg-4 col-6 search-field"
        @input="reload"
      />
    </div>
    <ListLoader
      class="account-list-wrapper"
      :class="$route.path.includes('clans') ? 'account-list-wrapper-sm' : ''"
      :is-loading="isLoading"
      :is-crashed="isCrashed"
      :is-empty-list="!usersList.length"
      :dummy-props="{
        iconName: 'dummy/friends',
        size: 200,
        headerText: $t(
          '_web_account-contacts_list-is-empty',
          'No data available'
        ),
        ...dummyProps,
      }"
      @reload="fetchList"
    >
      <template slot="list">
        <Paginated
          v-bind="{
            totalItems,
            hidePagination: !usersList.length,
            pageSize,
            inContainer: true,
            paginationProps: {
              isDark: true,
            },
          }"
          class="mb-0 h-auto"
          @change="fetchList"
        >
          <div class="col">
            <slot v-for="user in usersList" v-bind="{ user }" />
          </div>
        </Paginated>
        <PopoverActions v-model="popoverPosition" :items="popoverItems" />
      </template>
    </ListLoader>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import listMixin from '@/mixins/paginatedLists';
import HeraSearchInput from '@/components/molecules/form/HeraSearchInput';
import ListLoader from '@/components/common/HeraListPreloader';
import Paginated from '@/components/common/Paginated';
import PopoverActions from '@/views/account/lists/PopoverActions';
import { prop } from '@/utils/factories';

export default {
  name: 'ListWrapper',
  components: {
    PopoverActions,
    HeraSearchInput,
    ListLoader,
    Paginated,
  },
  mixins: [...listMixin],
  props: {
    hasSearch: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: String,
      required: true,
    },
    itemSource: {
      type: Function,
      required: true,
    },
    replaceItems: {
      type: Function,
      default: null,
    },
    popoverItems: {
      type: Array,
      default: () => [],
    },
    popoverPositionTarget: {
      type: [Object, Node],
      default: null,
    },
    dummyProps: prop(Object, null),
  },
  data() {
    return {
      userFilter: '',
      usersList: [],
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    popoverPosition: {
      get() {
        return (
          this.popoverPositionTarget &&
          this.popoverPositionTarget.closest('span')
        );
      },
      set(val) {
        if (!val) {
          this.$emit('hidePopover', val);
        }
      },
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    pingScroll() {
      this.$refs.infiniteScroll.setDebounceTestPage();
    },
    fetchList(newPage) {
      this.pageIndex = newPage;
      return this.getPageData(
        'usersList',
        this.itemSource({
          accountId: this.accountId,
          params: this.paramsWithPageNumber({
            contains: this.userFilter,
          }),
        }),
        { forEach: this.replaceItems }
      );
    },
    removeUser(user) {
      this.usersList = this.usersList.filter(item => item.login !== user.login);
    },
    updateUser(user) {
      const userIndex = this.usersList.findIndex(
        item => item.login === user.login
      );
      this.$set(this.usersList, userIndex, user);
    },
    reload() {
      this.pageIndex = 0;
      this.usersList = [];
      return this.fetchList();
    },
  },
};
</script>

<style lang="scss">
.tabs-container {
  //min-height: calc(100vh - 18rem);
}
.account-list-wrapper {
  background-color: $new-bg-page-faded;
  position: relative;
  // min-height: 400px;
  // max-height: calc(100vh - 18rem);
  .search-field + & {
    //  height: calc(100vh - 24rem);
  }
  .svg-icon-wrapper {
    height: 2.25rem;
  }
}

.account-list-unwrapper {
  padding: 1rem;
}

@media (max-width: 767px) {
  .account-list-wrapper-sm {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>
